import styled from 'styled-components/macro';

const NumericIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export default NumericIndicator;
